import { forwardRef } from "react";
import { TextWithLineBreaks } from "src/components";
import { ReactComponent as WarnIcon } from "src/assets/images/icons/warn-icon.svg";
import "src/tailwind.css";

interface FormLvlErrorMessageProps {
  message?: string;
  centred?: boolean;
}

const FormLvlErrorMessage = forwardRef<HTMLDivElement, FormLvlErrorMessageProps>(({ message, centred = true }, ref) => {
  if (!message) {
    return null;
  }

  const messageLines = message.split(/<br\s*\/?>|\n/).filter((line) => line.trim() !== "");
  const hasMultipleLines = messageLines.length > 1;

  return (
    <div
      ref={ref}
      className={`
        max-w-2xl p-2 mx-auto
        flex items-center ${hasMultipleLines ? "flex-col" : "flex-row"}
        space-x-2 ${hasMultipleLines ? "space-x-0 space-y-2" : "space-y-0"}
        text-red-700
        animate-[shake_0.5s_ease-out]
        bg-red-50 border border-red-200 rounded-lg
        ${centred ? "text-center" : "text-left"}
      `}
    >
      {hasMultipleLines ? (
        <>
          <div className="flex justify-center mb-1">
            <div className="flex items-center justify-center w-10 h-10 bg-red-100 rounded-full">
              <WarnIcon className="w-5 h-5 text-red-600" />
            </div>
          </div>

          <div className="text-red-800">
            <ul className="space-y-1 text-sm">
              {messageLines.map((line, index) => (
                <li key={index} className="flex items-center p-0 cursor-auto hover:bg-transparent hover:text-red-800">
                  <span className="inline-block w-1.5 h-1.5 bg-red-600 rounded-full mr-2 flex-shrink-0" />
                  <span>{line.trim()}</span>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <>
          <WarnIcon className="w-5 h-5 mb-1 mr-2" />
          <TextWithLineBreaks text={message} />
        </>
      )}
    </div>
  );
});

export { FormLvlErrorMessage };
